import { render, staticRenderFns } from "./bookingLogDialog.vue?vue&type=template&id=b39c2546&"
import script from "./bookingLogDialog.vue?vue&type=script&lang=js&"
export * from "./bookingLogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b39c2546')) {
      api.createRecord('b39c2546', component.options)
    } else {
      api.reload('b39c2546', component.options)
    }
    module.hot.accept("./bookingLogDialog.vue?vue&type=template&id=b39c2546&", function () {
      api.rerender('b39c2546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/bookingLogDialog.vue"
export default component.exports